import { useGoogleLogin } from "@react-oauth/google";
// import { isSafari, isMacOs, isIOS, isIOS13 } from "react-device-detect";
import { Card, CardContent, CardFooter, CardHeader } from "@ui/card";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { SVG } from "@components/items/common/SVG";
import { Separator } from "@ui/separator";
import TranslatedText from "@components/items/display/TranslatedText";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import {
  signInWithGoogle,
  useAppDispatch,
  useSignInWithGoogle,
} from "@lib/stores";
import { useLocation } from "react-router-dom";
import AppleLogin from "react-apple-login";
import { AuthActions } from "@lib/stores/auth/slices";
import { useLinkedAccounts } from "@components/layouts/b2c/profile/settings/hooks/useLinkedAccounts";
interface AppleLoginResponse {
  authorization: {
    code: string;
    id_token: string;
  };
}

export const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const { pathname, search } = useLocation();

  const currentUrl = pathname + search;

  console.log("currentUrl", currentUrl);
  const { status } = useSignInWithGoogle();

  const { isApplePopup } = useLinkedAccounts();

  const onGoogleSubmit = useGoogleLogin({
    onSuccess: (codeResponse) => {
      signInWithGoogle({ token: codeResponse.access_token });
    },
  });

  const onAppleSubmit = (response: AppleLoginResponse) => {
    if (response?.authorization?.id_token) {
      const {
        authorization: { id_token },
      } = response;

      dispatch(
        AuthActions.signInWithAppleAsync({
          token: id_token,
        })
      );
    }
  };

  return (
    <Card className="relative border-none bg-[#2D2E35] p-2 sm:p-5">
      {status === "loading" ? (
        <div className="absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-gray-500/75">
          <div className="mx-auto mt-24 h-14 w-14 sm:mt-[35px]">
            <div className="h-full w-full">
              <div className="h-full w-full animate-spin rounded-full border-[3px] border-white border-b-transparent"></div>
            </div>
          </div>
        </div>
      ) : null}
      <CardHeader className="items-center justify-center gap-4">
        <TranslatedText
          text={`onboarding.titles.${"enter your email address to continue"}`}
          className="text-[16px] font-bold leading-normal text-white"
        />
        <div className="flex flex-col items-center justify-center gap-4">
          {/* {(isIOS || isIOS13 || isMacOs || isSafari) && ( */}
          <AppleLogin
            clientId="7ULS9RAK3M.octadevtn.wamdha"
            redirectURI={window.location.origin}
            responseMode="query"
            usePopup={isApplePopup}
            render={(renderProps) => (
              <ShadcnButton
                className="flex w-[270px] items-center justify-start gap-6 bg-[#F3F3F3] px-5 text-black hover:bg-[#F3F3F3]/80 sm:w-[300px] dark:bg-[#F3F3F3] dark:hover:bg-[#F3F3F3]"
                action={renderProps.onClick}
              >
                <SVG src="/assets/icons/apple.svg" />
                <TranslatedText
                  text={`onboarding.buttons.${"sign in using apple"}`}
                  className="!text-black"
                />
              </ShadcnButton>
            )}
            callback={onAppleSubmit}
          />
          {/* )} */}
          <ShadcnButton
            className="flex w-[270px] items-center justify-start gap-6 bg-[#F3F3F3] px-5 text-black hover:bg-[#F3F3F3]/80 sm:w-[300px] dark:bg-[#F3F3F3] dark:hover:bg-[#F3F3F3]"
            onClick={() => {
              onGoogleSubmit();
            }}
          >
            <SVG src="/assets/icons/google.svg" />
            <TranslatedText
              text={`onboarding.buttons.${"sign in using google"}`}
              className="!text-black"
            />
          </ShadcnButton>
          <ShadcnButton
            className="flex w-[270px] items-center justify-start gap-6 bg-white px-5 text-black hover:bg-[#F3F3F3]/80 sm:w-[300px] dark:bg-[#F3F3F3] dark:hover:bg-[#F3F3F3]"
            onClick={() => navigate("/login/phone")}
          >
            <SVG src="/assets/icons/phone.svg" className="min-w-[18px]" />
            <TranslatedText
              text={`onboarding.buttons.${"sign in using phone"}`}
              className="!text-black"
            />
          </ShadcnButton>
        </div>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center gap-4">
        <div className="flex items-center justify-center">
          <Separator className="w-[85px] bg-white" />
          <TranslatedText
            text={`onboarding.titles.${"or via"}`}
            className="mx-4 flex-shrink text-[11px] text-white"
          />
          <Separator className="w-[85px] bg-white" />
        </div>
        <div className="flex items-center justify-center">
          <ShadcnButton
            className="flex w-[270px] items-center justify-center gap-3 text-white sm:w-[300px] dark:text-[#010D19]"
            onClick={() => navigate("/login/email")}
          >
            <SVG
              src="/assets/icons/email.svg"
              preProcessor={(code: string) =>
                code
                  .replace(/(fill=)"(?!none")[^"]+"/g, 'fill="currentColor"')
                  .replace(
                    /(stroke=)"(?!none")[^"]+"/g,
                    'stroke="currentColor"'
                  )
              }
              className="dark:text-[#010D19]"
            />
            <TranslatedText
              text={`onboarding.buttons.${"continue using email"}`}
            />
          </ShadcnButton>
        </div>
        <div className="flex items-center justify-center">
          <ShadcnButton
            className="flex w-[270px] items-center justify-center gap-3 bg-transparent text-white hover:bg-transparent sm:w-[300px] dark:text-[#010D19]"
            onClick={() => navigate("/login/b2b")}
          >
            <TranslatedText
              text={`onboarding.buttons.sign in via your company`}
            />
          </ShadcnButton>
        </div>
      </CardContent>
      <CardFooter className="flex items-center justify-center gap-1 text-[10px] font-bold text-white">
        <TranslatedText
          text={`onboarding.titles.${"by continuing, you agree to"}`}
        />
        <a
          href="https://wajeez.com/tos?lang=ar"
          target="_blank"
          rel="noreferrer"
        >
          <TranslatedText
            text={`onboarding.titles.${"terms of service"}`}
            className="dark:text-dark-primary text-primary"
          />
        </a>
        <TranslatedText text={`onboarding.titles.${"and"}`} />
        <a
          href="https://wajeez.com/privacy?lang=ar"
          target="_blank"
          rel="noreferrer"
        >
          <TranslatedText
            text={`onboarding.titles.${"privacy policy"}`}
            className="dark:text-dark-primary text-primary"
          />
        </a>
      </CardFooter>
    </Card>
  );
};
